import clsx from "clsx";

import { useIsMobile } from "@smart/itops-hooks-dom";
import { Button, IconName } from "@smart/itops-sb-design-system-dom";

import { useVoiceConversationContext } from "../hooks/voice-conversation";

export const VoiceConversation = ({
  onUseVoice,
}: {
  onUseVoice?: () => void;
}) => {
  const { isActive, isListening, isSupported, toggle } =
    useVoiceConversationContext();
  const isMobile = useIsMobile();

  const getIcon = (): IconName => {
    if (isActive) {
      return "solidWaveformLines";
    }
    return "regularWaveformLines";
  };

  if (!isSupported) {
    return null;
  }

  const buttonText = isActive ? "Stop Voice" : "Use Voice";

  return (
    <>
      <style>{`
        @keyframes waveform-bars {
          0% {
            clip-path: polygon(
              0% 45%, 100% 45%, 100% 55%, 0% 55%,0% 45%
            );
          }
          10% {
            clip-path: polygon(
              0% 40%, 100% 40%, 100% 60%, 0% 60%,0% 40%
            );
          }
          20% {
            clip-path: polygon(
              0% 30%, 100% 30%, 100% 70%, 0% 70%,0% 30%
            );
          }
          30% {
            clip-path: polygon(
              0% 20%, 100% 20%, 100% 80%, 0% 80%,0% 20%
            );
          }
          40% {
            clip-path: polygon(
              0% 10%, 100% 10%, 100% 90%, 0% 90%,0% 10%
            );
          }
          50% {
            clip-path: polygon(
              0% 0%, 100% 0%, 100% 100%, 0% 100%,0% 0%
            );
          }
          60% {
            clip-path: polygon(
              0% 10%, 100% 10%, 100% 90%, 0% 90%,0% 10%
            );
          }
          70% {
            clip-path: polygon(
              0% 20%, 100% 20%, 100% 80%, 0% 80%,0% 20%
            );
          }
          80% {
            clip-path: polygon(
              0% 30%, 100% 30%, 100% 70%, 0% 70%,0% 30%
            );
          }
          90% {
            clip-path: polygon(
              0% 40%, 100% 40%, 100% 60%, 0% 60%,0% 40%
            );
          }
          100% {
            clip-path: polygon(
              0% 45%, 100% 45%, 100% 55%, 0% 55%,0% 45%
            );
          }
        }
      `}</style>
      <Button
        branded
        size="small"
        variant="primarySubtle"
        text={isMobile ? undefined : buttonText}
        isPressed={isActive}
        onClick={() => {
          if (!isActive) onUseVoice?.();
          toggle();
        }}
        leftIcon={getIcon()}
        className={clsx(
          isListening &&
            "[&_svg]:animate-[waveform-bars_2s_ease-in-out_infinite]",
          isMobile && "px-[1.6rem] max-w-[6.4rem]",
        )}
        aria-label={buttonText}
      />
    </>
  );
};
